export const otherModule = {
  loadingPay: "正在獲取支付結果",
  goDetail: "跳轉訂單詳情"
};
